import React from "react"
import styled, {createGlobalStyle} from 'styled-components'
import CloseBtn from "../CloseBtn";
import PollContent from "./PollContent";

const PollMainBlock = styled.div`
  background-color: #02B956;
  height: 100vh;
  box-sizing: border-box;
  padding: 0 20px;
`

const GlobalStyle = createGlobalStyle`
  body, html {
    background-color: #02B956;
  }
`

const Poll = ({nextFunc, timeout, poll}) => {
    return (
        <>
            <GlobalStyle/>
            <PollMainBlock>
                <CloseBtn count={timeout} clearDelay={nextFunc}/>
                <PollContent
                    // setFlag={setFlag}
                    nextFunc={nextFunc}
                    question={poll.question}
                    options={poll.opt}
                />
            </PollMainBlock>
        </>
    )
}

export default Poll